import { useEffect, useRef } from "react";
import Lenis from "lenis";
import axios from "axios";
import "@/App.css";
import { Nav } from "@/components/Nav";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Outcomes } from "@/components/Outcomes";
import { Workflow } from "@/components/Workflow";
import { Waitlist } from "@/components/Waitlist";
import { Footer } from "@/components/Footer";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function App() {
  const lenisRef = useRef(null);

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    lenisRef.current = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);

    if (!sessionStorage.getItem("tv_pv")) {
      sessionStorage.setItem("tv_pv", "1");
      axios.post(`${API}/analytics/pageview`).catch(() => {});
    }

    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  const scrollTo = (id) =>
    lenisRef.current?.scrollTo(id, { offset: -72, duration: 1.5 });

  return (
    <div className="App grain" data-testid="truvon-landing">
      <Nav onCta={() => scrollTo("#waitlist")} />
      <main>
        <Hero onCta={() => scrollTo("#waitlist")} />
        <Marquee />
        <Outcomes />
        <Workflow />
        <Waitlist />
      </main>
      <Footer />
    </div>
  );
}
